// import { cashfreeSandbox, cashfreeProd } from "cashfree-dropjs";
import { load } from "@cashfreepayments/cashfree-js";

function useCasefree(cUID, onPaymentSuccess, onPaymentFailure) {
  const activateCasefreeModal = async (
    amount,
    order_token,
    paymentMethod,
    backendOrderId
  ) => {
    const cashfree = await load({
      mode: "sandbox", //or production
      // mode: "production" // production
    });

    document.querySelector(".checkout-sub-container").style.display = "none";

    const checkout_container = document.getElementById("checkout_container");

    const cashfree_div_element = document.createElement("div");
    cashfree_div_element.setAttribute("id", "cashfree_div_element");
    checkout_container.appendChild(cashfree_div_element);

    if (cashfree) {
      console.log("cashfree:", cashfree.checkout);
      let checkoutOptions = {
        paymentSessionId: order_token,
        // returnUrl: "https://test.cashfree.com/pgappsdemos/v3success.php?myorder={order_id}",
        // redirectTarget:"_modal",
        redirectTarget: document.getElementById("cashfree_div_element"),
      };
      cashfree.checkout(checkoutOptions).then(function (result) {
        if (result.error) {
          // This will be true when there is any error during the payment
          // console.log("There is some payment error, Check for Payment Status");
          console.log("result.error:", result.error);
          // console.log("result:",result);
          //on failure during payment initiation
          document.getElementById("cashfree_div_element").remove();
          onPaymentFailure(backendOrderId, order_token);
        }
        if (result.redirect) {
          // This will be true when the payment redirection page couldnt be opened in the same window
          // This is an exceptional case only when the page is opened inside an inAppBrowser
          // In this case the customer will be redirected to return url once payment is completed
          // console.log("Payment will be redirected");
          console.log("result of redirect:", result);
        }
        if (result.paymentDetails) {
          // This will be called whenever the payment is completed irrespective of transaction status
          // console.log("Payment has been completed, Check for Payment Status");
          // console.log("result.paymentDetails.paymentMessage:",result.paymentDetails.paymentMessage);
          console.log("result:", result);
          onPaymentSuccess(cUID, backendOrderId, order_token);
        }
      });
    }
  };
  return [activateCasefreeModal];
}

export default useCasefree;
